const commonRoles = ["admin", "vendor"];

const ROLES = {
  orion: [...commonRoles, "external_operator"],
  canal_cliente_ream: [...commonRoles, "customer"],
  "modify-checklist": [...commonRoles, "modify-checklist", "admin-checklist"],
  "admin-checklist": [...commonRoles, "modify-checklist", "admin-checklist"],
  checklist: [...commonRoles, "checklist"],
  nexus: ["admin", "nexus"],
};

export default ROLES;

export const ANY_ROLE = "*";

export const hasRuleAccess = (
  userRoles: string[] | undefined,
  rules: string | null
): boolean => {
  if (!userRoles?.length) return false;
  if (rules === ANY_ROLE) return true;
  return userRoles.some((role) => ROLES[rules]?.includes(role));
};
